import React from 'react';
import { compose, withHandlers, withProps, lifecycle } from 'recompose';

import BarberLocations from '../components/BarberLocations';
import withToggle from '../../../common/hoc/withToggle';

export default compose(
  withProps(() => ({
    columnContainerRef: React.createRef(),
    locationsStringRef: React.createRef(),
  })),
  withToggle('expanded', false),
  withToggle('canExpand', false),
  withHandlers({
    onExpand: props => (e) => {
      e.preventDefault();
      props.expandedOn();
    },
  }),
  lifecycle({
    componentDidMount() {
      const isColumnContainerPresent = this.props.columnContainerRef && this.props.columnContainerRef.current;
      const isLocationStringPresent = this.props.locationsStringRef && this.props.locationsStringRef.current;
      if (isColumnContainerPresent && isLocationStringPresent) {
        const locationsStringBoxWidth = this.props.locationsStringRef.current.getBoundingClientRect().width;
        const containerBoxWidth = this.props.columnContainerRef.current.getBoundingClientRect().width;
        if (locationsStringBoxWidth > containerBoxWidth) {
          this.props.canExpandOn(true);
        }
      }
    },
  }),
)(BarberLocations);
